<mat-icon [matTooltip]="'keys.local.tooltips.feature_is_commercially_info' | translate" class="hb-right-icon"
          color="info"
          fontIcon="fa-exclamation-circle"
          fontSet="fas"
          matTooltipTouchGestures="on">
</mat-icon>
